<template>
  <div class="login">
    <!--ログインコンポーネント-->
    <amplify-authenticator></amplify-authenticator>
    <amplify-sign-out></amplify-sign-out>
  </div>
</template>

<script>
export default {
  name: "login"
};
</script>
